
import React from 'react';

function WorkProcessSection() {
  return (
    <div className="our-work-process dark-section">
      <div className="container">
        <div className="row section-row">
          <div className="col-lg-12">
            <div className="section-title section-title-center">
              <h3 className="wow fadeInUp">our work process</h3>
              <h2 className="text-anime-style-2" data-cursor="-opaque">Reliable moving services built <span>around you</span></h2>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="wrok-process-list">
            <div className="work-process-item wow fadeInUp">
              <div className="icon-box">
                <img src="/hellotruck-web-images/icon-work-process-1.svg" alt="" />
                <div className="work-process-number">
                  <h3>1</h3>
                </div>
              </div>
              <div className="work-process-content">
                <h3>Book Online OR Get a Quote</h3>
                <p>You can simply book online, or Start by contacting us and share your moving details.</p>
              </div>
            </div>

            <div className="work-process-item wow fadeInUp" data-wow-delay="0.2s">
              <div className="icon-box">
                <img src="/hellotruck-web-images/icon-work-process-2.svg" alt="" />
                <div className="work-process-number">
                  <h3>2</h3>
                </div>
              </div>
              <div className="work-process-content">
                <h3>plan your move</h3>
                <p>Our team works with you on the booking request - From packing to logistics.</p>
              </div>
            </div>

            <div className="work-process-item wow fadeInUp" data-wow-delay="0.4s">
              <div className="icon-box">
                <img src="/hellotruck-web-images/icon-work-process-3.svg" alt="" />
                <div className="work-process-number">
                  <h3>3</h3>
                </div>
              </div>
              <div className="work-process-content">
                <h3>safe & secure moving</h3>
                <p>Our expert movers handle your belongings with care, using high-quality packing materials.</p>
              </div>
            </div>

            <div className="work-process-item wow fadeInUp" data-wow-delay="0.6s">
              <div className="icon-box">
                <img src="/hellotruck-web-images/icon-work-process-4.svg" alt="" />
                <div className="work-process-number">
                  <h3>4</h3>
                </div>
              </div>
              <div className="work-process-content">
                <h3>unpack & settle in</h3>
                <p>Once we've delivered your items, we'll help with unpacking and setting up, so you can enjoy.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WorkProcessSection;
